/** * 系统管理 用户管理 */
<template>
  <div>
    <div class="query-select">
      <el-form :inline="true" :model="queryParams" class="user-search">
        <el-form-item label="用户名">
          <el-input
            v-model.trim="queryParams.userName"
            placeholder="请输入用户名"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input
            v-model.trim="queryParams.phonenumber"
            placeholder="请输入手机号"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="div_select_button">
        <el-button plain round size="small"
          type="primary"
          icon="el-icon-search"
          @click="handleQuery"
          >查询</el-button
        >
        <el-button plain round size="small"
          type="warning"
          icon="el-icon-refresh-left"
          @click="resetQuery"
          >重置</el-button
        >
        <el-button plain round size="small"
          type="success"
          icon="el-icon-plus"
          @click="dialogShow('add')"
          >新增</el-button
        >
      </div>
    </div>

    <div class="main-table">
      <el-table
        size="small"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        stripe
        header-cell-class-name="table-header"
        element-loading-text="拼命加载中"
        style="width: 100%;"
      >
        <el-table-column align="center" prop="nickName" label="昵称">
        </el-table-column>
        <el-table-column align="center" prop="userName" label="用户名">
        </el-table-column>

        <el-table-column
          align="center"
          prop="phonenumber"
          label="手机号"
          width="160"
        >
        </el-table-column>

        <el-table-column
          align="center"
          prop="createTime"
          label="创建时间"
          min-width="120"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.createTime }}</div>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作" width="340">
          <template slot-scope="scope">
            <el-button plain round size="small"
              type="warning"
              @click="dialogShow('edit', scope.row)"
              >编辑</el-button
            >
            <el-button plain round size="small"
              type="danger"
              @click="deleteUser(scope.row)"
              >删除</el-button
            >
            <el-button plain round size="small"
              type="primary"
              @click="resetpwd(scope.row)"
              >重置密码</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="queryParams.pageNum"
        :page-size="queryParams.pageSize"
        layout="total, prev, pager, next"
        :total="totals"
      >
      </el-pagination>
    </div>

    <UserForm ref="formRef" @success="getList"></UserForm>
  </div>
</template>

<script>
import { userList, userDelete, userPwd, userLock } from "@/api/system/user";
import { generateStrongPassword } from "@/utils/validate";
import UserForm from "./UserForm.vue";

export default {
  components: {
    UserForm
  },
  data() {
    return {
      loading: false,
      listData: [],
      totals: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        userName: null,
        phonenumber: null
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      this.loading = true;

      try {
        const result = await userList(this.queryParams);

        this.listData = (result.data && result.data.rows) || [];
        this.totals = (result.data && result.data.total) || 0;
      } catch (e) {
      } finally {
        this.loading = false;
      }
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getList();
    },
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        userName: null,
        phonenumber: null
      };
      this.getList();
    },
    dialogShow(type, row = {}) {
      this.$refs.formRef.open(type, row);
    },
    async editType(row, enabled) {
      const parm = {
        userId: row.userId,
        lock: enabled ? "N" : "Y"
      };
      try {
        const result = await userLock(parm);

        this.$message.success("状态修改成功");
        this.getList();
      } catch (e) {}
    },
    async deleteUser(row) {
      try {
        await this.$confirm("确定要删除吗?", "信息", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        });
        const result = await userDelete(row.userId);

        this.$message.success("删除成功");
        this.getList();
      } catch (e) {}
    },
    async resetpwd(row) {
      try {
        await this.$confirm(
          `确定要为用户「${row.userName}」重置密码吗？系统将自动生成强密码。`,
          "重置密码",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        );
        const password = generateStrongPassword();
        const result = await userPwd({ userId: row.userId, password });

        this.$alert(`新密码为：${password}`, "重置密码成功", {
          confirmButtonText: "确定",
          type: "success"
        });
      } catch (e) {}
    }
  }
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/system/User/index.vue